import { OverlayHandler } from "./OverlayHandler";

export class OverlayListener extends OverlayHandler {
  constructor(readonly element: Element) {
    super();
  }

  /**
   *
   * @param {(...params: any) => void} func
   * @param {[Element, (HTMLElement | null)[]]} arg
   * @returns {void}
   */
  listen(func: (...params: any) => void, arg: [Element, (HTMLElement | null)[]]): void {
    this.element.addEventListener("click", this.handler.bind(this.element, this, func, arg));
  }
  unlisten(func: (...params: any) => void, arg: [Element, (HTMLElement | null)[]]): void {
    this.element.removeEventListener("click", this.handler.bind(this.element, this, func, arg));
  }
}
